module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-36.467288cb.png";